import { render, staticRenderFns } from "./SubscriptionPlanContent.vue?vue&type=template&id=5e879b2c&scoped=true&"
import script from "./SubscriptionPlanContent.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlanContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e879b2c",
  null
  
)

/* custom blocks */
import block0 from "./SubscriptionPlanContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VChip,VIcon,VSwitch})
